import React from 'react';
import i18n from '../../../i18n';
import { makeStyles } from '@material-ui/core/styles';
import { Field, reduxForm } from 'redux-form';
import { string } from 'yup';

import { useFormError, validator } from 'core/form/form';

import { FormErrorMessage } from 'components/FormErrorMessage/FormErrorMessage';
import { Icon } from 'components/Icon/Icon';
import { Text, TextTypography } from 'components/Text/Text';
import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';
import { MobilePhoneControlField } from 'components/MobilePhoneControl/MobilePhoneControl';

import { ReactComponent as ResetPasswordIcon } from 'assets/glyphs/password.svg';

import { Form } from 'forms/types';
import { Grid } from '@material-ui/core';
import { RoutePath } from 'RoutePath';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        textAlign: 'center',
    },
    contents: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    title: {
        marginTop: theme.spacing(3.5),
        marginBottom: theme.spacing(3),
    },
    description: {
        maxWidth: 400,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        marginRight: 'auto',
        marginLeft: 'auto',
    },
    phone: {
        maxWidth: 375,
        margin: 'auto',
    },
    field: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    footer: {
        flexGrow: 0,
        flexBasis: 'auto',
        marginBottom: theme.spacing(2),
    },
    footerButton: {
        maxWidth: 375,
        margin: 'auto',
    },
}));

export const PasswordResetPhoneForm = reduxForm({
    form: Form.PASSWORD_RESET_PHONE_FORM,
    initialValues: { phone: '' },
    validate: validator({
        phone: string().required('common:validation.required'),
    }),
})(props => {
    const { handleSubmit } = props;
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    const error = useFormError(Form.PASSWORD_RESET_PHONE_FORM);
    return (
        <form className={classes.container} onSubmit={handleSubmit}>
            <div className={classes.contents}>
                <Grid container direction={'column'} justify={'center'}>
                    <Grid>
                        <Icon component={ResetPasswordIcon} size={64} svgSize={64} />
                    </Grid>
                    <Grid>
                        <div className={classes.title}>
                            <Text typography={TextTypography.DISPLAY_STRONG}>
                                {t('auth:resetPassword.phone.title')}
                            </Text>
                        </div>
                    </Grid>
                    <Grid>
                        <div className={classes.description}>
                            <Text typography={TextTypography.PARA}>{t('auth:resetPassword.phone.description')}</Text>
                        </div>
                    </Grid>
                    <Grid>
                        <div className={classes.phone}>
                            <Field
                                name="phone"
                                component={MobilePhoneControlField}
                                label={t('auth:resetPassword.phone.phoneNumber')}
                                autoFocus={true}
                            />
                            {error && (
                                <div className={classes.field}>
                                    <FormErrorMessage error={error} />
                                </div>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div className={classes.footer}>
                <Grid container spacing={1} direction={'column'} justify={'center'}>
                    <Grid item>
                        <div className={classes.footerButton}>
                            <LargeButton type="submit">{t('auth:resetPassword.phone.resetPassword')}</LargeButton>
                        </div>
                    </Grid>
                    <Grid item>
                        <div className={classes.footerButton}>
                            <Link to={RoutePath.LOGIN}>
                                <LargeButton color={LargeButtonColor.TRANSPARENT}>
                                    {t('auth:resetPassword.phone.login')}
                                </LargeButton>
                            </Link>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </form>
    );
});
